import { render, staticRenderFns } from "./loading-spinner.vue?vue&type=template&id=28e66b1a&scoped=true&"
import script from "./loading-spinner.vue?vue&type=script&lang=ts&"
export * from "./loading-spinner.vue?vue&type=script&lang=ts&"
import style0 from "./loading-spinner.vue?vue&type=style&index=0&id=28e66b1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e66b1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28e66b1a')) {
      api.createRecord('28e66b1a', component.options)
    } else {
      api.reload('28e66b1a', component.options)
    }
    module.hot.accept("./loading-spinner.vue?vue&type=template&id=28e66b1a&scoped=true&", function () {
      api.rerender('28e66b1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/component/misc/loading-spinner.vue"
export default component.exports